import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { createContact, reset } from '../features/contact/contactSlice'
import { sendPageView } from '../gtmUtils'
import Spinner from '../components/Spinner'
import BackButton from '../components/BackButton'

function Contact() {
	const [formData, setFormData] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phoneNumber: '',
		contactMethod: 'email',
		timeToContact: 'anytime',
		comments: '',
	})

	const { isLoading, isError, isSuccess, message } = useSelector((state) => state.contact)

	const { firstName, lastName, email, phoneNumber, contactMethod, timeToContact, comments } =
		formData

	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		sendPageView()
	}, [])

	useEffect(() => {
		if (isError) {
			toast.error(message)
		}

		if (isSuccess) {
			dispatch(reset())
			toast.success(
				'Message has been successfully sent.  Typical response is within 2 hours during business hours.',
			)
			navigate('/')
		}

		dispatch(reset())
	}, [dispatch, isError, isSuccess, navigate, message])

	const onSubmit = (e) => {
		e.preventDefault()
		dispatch(createContact(formData))
	}

	const onChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}))
	}

	if (isLoading) {
		return <Spinner />
	}

	return (
		<div className='container contact'>
			<BackButton url='/' />

			<section className='heading'>
				<h1>Contact Information</h1>
				<p className='p-1'>Please fill out the form below</p>
			</section>

			<section className='form'>
				<form onSubmit={onSubmit}>
					<div className='form-group'>
						<label htmlFor='firstName'>First Name</label>
						<input
							type='text'
							className='form-control'
							id='firstName'
							name='firstName'
							value={firstName}
							onChange={onChange}
							required
						/>
					</div>
					<div className='form-group'>
						<label htmlFor='lastName'>Last Name</label>
						<input
							type='text'
							className='form-control'
							id='lastName'
							name='lastName'
							value={lastName}
							onChange={onChange}
							required
						/>
					</div>
					<div className='form-group'>
						<label htmlFor='email'>E-Mail</label>
						<input
							type='text'
							className='form-control'
							id='email'
							name='email'
							value={email}
							onChange={onChange}
						/>
					</div>
					<div className='form-group'>
						<label htmlFor='phoneNumber'>Phone Number</label>
						<input
							type='text'
							className='form-control'
							id='phoneNumber'
							name='phoneNumber'
							value={phoneNumber}
							onChange={onChange}
						/>
					</div>
					<div className='form-group'>
						<label htmlFor='contactMethod'>Preferred Contact Method</label>
						<br />
						<label>
							<input
								type='radio'
								className='form-control'
								id='contactMethod'
								name='contactMethod'
								value='email'
								checked={contactMethod === 'email'}
								onChange={onChange}
							/>{' '}
							E-Mail
						</label>
						<label>
							<input
								type='radio'
								className='form-control'
								style={{ marginLeft: '10px' }}
								id='contactMethod'
								name='contactMethod'
								value='phone'
								checked={contactMethod === 'phone'}
								onChange={onChange}
							/>{' '}
							Phone
						</label>
					</div>
					<div className='form-group'>
						<label htmlFor='timeToContact'>Preferred Contact Time</label>
						<br />
						<label>
							<input
								type='radio'
								className='form-control'
								id='timeToContact'
								name='timeToContact'
								value='morning'
								checked={timeToContact === 'morning'}
								onChange={onChange}
							/>{' '}
							Morning
						</label>
						<label>
							<input
								type='radio'
								className='form-control'
								style={{ marginLeft: '10px' }}
								id='timeToContact'
								name='timeToContact'
								value='afternoon'
								checked={timeToContact === 'afternoon'}
								onChange={onChange}
							/>{' '}
							Afternoon
						</label>
						<label>
							<input
								type='radio'
								className='form-control'
								style={{ marginLeft: '10px' }}
								id='timeToContact'
								name='timeToContact'
								value='evening'
								checked={timeToContact === 'evening'}
								onChange={onChange}
							/>{' '}
							Evening
						</label>
						<label>
							<input
								type='radio'
								className='form-control'
								style={{ marginLeft: '10px' }}
								id='timeToContact'
								name='timeToContact'
								value='anytime'
								checked={timeToContact === 'anytime'}
								onChange={onChange}
							/>{' '}
							Anytime
						</label>
					</div>
					<div className='form-group'>
						<label htmlFor='comments'>Comments</label>
						<textarea
							name='comments'
							id='comments'
							className='form-control'
							placeholder='Please describe what kind of request you would like to discuss.'
							rows={5}
							value={comments}
							onChange={onChange}></textarea>
					</div>
					<div className='form-group'>
						<button className='btn btn-black'>Submit</button>
					</div>
				</form>
			</section>
		</div>
	)
}

export default Contact
